import React, { ReactElement, useContext } from 'react'

import Heading from '../../Common/Components/Heading'
import Fieldset from '../../Common/Components/Fieldset'
import P from '../../Common/Components/P'
import Checkbox from '../../Common/Components/Checkbox'
import FormRow from '../../Common/Components/FormRow'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { Audit as AuditLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'

/**
 * Component properties type.
 */
type Props = {
    enableRptRequestAudit: boolean
    setEnableRptRequestAudit: (checked: boolean) => void
}

/**
 * Audit section in Advanced tab of report configuration modal window.
 *
 * @param enableRptRequestAudit Report property.
 * @param setEnableRptRequestAudit Setter for corresponding report property.
 *
 */
const Audit: React.FC<Props> = ({ enableRptRequestAudit, setEnableRptRequestAudit }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('Audit')

    return (
        <Fieldset className={'audit'}>
            <Heading level={HeadingLevel.ONE}>{language.get(AuditLanguage.Audit_SectionHeader)}</Heading>
            <P>{language.get(AuditLanguage.Audit_SectionPara)}</P>
            <FormRow isInline className={'enable-report-request-audit'}>
                <Checkbox
                    onChange={setEnableRptRequestAudit}
                    isChecked={enableRptRequestAudit}
                    labelLeft={language.get(AuditLanguage.EnablerptrequestauditLabel)}
                />
            </FormRow>
        </Fieldset>
    )
}

export default React.memo(Audit)
